/**
 * VehiclesPanel — wiederverwendbarer Fahrzeuge-Tab.
 *
 * Eigenständiges Suchfeld + die bestehende `VehiclesTab` (Bestand + Kunden-
 * fahrzeuge, Filter, Bearbeiten/Verschieben/Auftrag, Pagination). Wird unter
 * „Rechnungen & Kunden" und in „Werkstatt-Aufträge" identisch genutzt.
 */
import { useState } from "react";
import { Search } from "lucide-react";
import { Input } from "../ui/input";
import { VehiclesTab } from "../../pages/InvoicesPage";

export default function VehiclesPanel() {
    const [searchQ, setSearchQ] = useState("");
    return (
        <div data-testid="vehicles-panel">
            <div className="relative mb-4">
                <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-emerald-600" />
                <Input
                    value={searchQ}
                    onChange={(e) => setSearchQ(e.target.value)}
                    placeholder="Fahrzeuge suchen (Titel, Modell, Hersteller, FIN, Kennzeichen, Bestellcode, Standort…)"
                    className="pl-9 rounded-sm border-2 border-emerald-500 focus:border-emerald-600 focus-visible:ring-emerald-400 placeholder:text-emerald-700/70"
                    data-testid="vehicles-panel-search"
                />
            </div>
            <VehiclesTab searchQ={searchQ} onTotal={() => {}} />
        </div>
    );
}
